import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-my-plan',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './my-plan.component.html',
  styleUrl: './my-plan.component.scss'
})
export class MyPlanComponent implements OnInit {
  email = localStorage.getItem('email') || '';
  idUser = Number(localStorage.getItem('id') || 0);
  plan: string = 'free';

  constructor(private userService: UserService) { }

  ngOnInit(): void {
  this.userService.getUserPlan(this.idUser).subscribe({
    next: (response) => {
      this.plan = response?.plan || 'free';
      localStorage.setItem('plan', this.plan);
    },
    error: () => {
      this.plan = 'free';
      localStorage.setItem('plan', this.plan); 
    }
  });
}

  goToUpgrade() {
    const url = `https://mercadopago.futuroacs.com.br/?email=${encodeURIComponent(this.email)}&id_user=${this.idUser}`;
    window.location.href = url;
  }
}
